import React from 'react';
import UserLookupFieldSelectView from '../view/UserLookupFieldSelectView';

const SelectUsersEngine = ({ ...props }) => {
  const root = props.additionalParameters && props.additionalParameters.root;
  const lookupFieldId = root && root.lookupFieldId;

  const viewProps = {
    lookupFieldId,
    ...props
  };

  return <UserLookupFieldSelectView {...viewProps} />;
};

export default SelectUsersEngine;
